import React from 'react';
import RLSkeleton from 'react-loading-skeleton';

// NOTE: react-loading-skeleton's published .d.ts files re-export their types
// with `.js` extensions (e.g. `from './Skeleton.js'`), which TypeScript cannot
// resolve under CRA's `moduleResolution: "node"`. That collapses the library's
// SkeletonProps to an empty type, so `width`/`height`/`circle` appear invalid at
// every call site. We declare the props explicitly here to sidestep that.
export interface SkeletonProps {
  count?: number;
  wrapper?: React.FunctionComponent<React.PropsWithChildren<unknown>>;
  className?: string;
  containerClassName?: string;
  containerTestId?: string;
  circle?: boolean;
  style?: React.CSSProperties;
  baseColor?: string;
  highlightColor?: string;
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  inline?: boolean;
  duration?: number;
  direction?: 'ltr' | 'rtl';
  enableAnimation?: boolean;
  customHighlightBackground?: string;
}

export const Skeleton: React.FC<SkeletonProps> = (props) => <RLSkeleton {...props} />;
